export enum FontsFamily {
    Sofia_Pro = 'Sofia Pro',
    Roboto = 'Roboto'
}